export const MAJOR_ARCANA = [
    { id: 'major_00', arcana: 'major', number: 0, nameRu: 'Шут', nameEn: 'The Fool', keywordsRu: ['начало', 'свобода', 'спонтанность'], keywordsEn: ['beginning', 'freedom', 'spontaneity'], imageKey: 'major_00_fool' },
    { id: 'major_01', arcana: 'major', number: 1, nameRu: 'Маг', nameEn: 'The Magician', keywordsRu: ['воля', 'действие', 'мастерство'], keywordsEn: ['will', 'action', 'mastery'], imageKey: 'major_01_magician' },
    { id: 'major_02', arcana: 'major', number: 2, nameRu: 'Верховная Жрица', nameEn: 'The High Priestess', keywordsRu: ['интуиция', 'тайна', 'внутренний голос'], keywordsEn: ['intuition', 'mystery', 'inner voice'], imageKey: 'major_02_high_priestess' },
    { id: 'major_03', arcana: 'major', number: 3, nameRu: 'Императрица', nameEn: 'The Empress', keywordsRu: ['плодородие', 'забота', 'изобилие'], keywordsEn: ['fertility', 'nurturing', 'abundance'], imageKey: 'major_03_empress' },
    { id: 'major_04', arcana: 'major', number: 4, nameRu: 'Император', nameEn: 'The Emperor', keywordsRu: ['структура', 'власть', 'порядок'], keywordsEn: ['structure', 'authority', 'order'], imageKey: 'major_04_emperor' },
    { id: 'major_05', arcana: 'major', number: 5, nameRu: 'Иерофант', nameEn: 'The Hierophant', keywordsRu: ['традиция', 'наставничество', 'учение'], keywordsEn: ['tradition', 'mentorship', 'teaching'], imageKey: 'major_05_hierophant' },
    { id: 'major_06', arcana: 'major', number: 6, nameRu: 'Влюблённые', nameEn: 'The Lovers', keywordsRu: ['союз', 'выбор', 'любовь'], keywordsEn: ['union', 'choice', 'love'], imageKey: 'major_06_lovers' },
    { id: 'major_07', arcana: 'major', number: 7, nameRu: 'Колесница', nameEn: 'The Chariot', keywordsRu: ['воля', 'движение', 'победа'], keywordsEn: ['willpower', 'momentum', 'victory'], imageKey: 'major_07_chariot' },
    { id: 'major_08', arcana: 'major', number: 8, nameRu: 'Сила', nameEn: 'Strength', keywordsRu: ['мягкая сила', 'мужество', 'терпение'], keywordsEn: ['gentle strength', 'courage', 'patience'], imageKey: 'major_08_strength' },
    { id: 'major_09', arcana: 'major', number: 9, nameRu: 'Отшельник', nameEn: 'The Hermit', keywordsRu: ['одиночество', 'мудрость', 'поиск'], keywordsEn: ['solitude', 'wisdom', 'inner search'], imageKey: 'major_09_hermit' },
    { id: 'major_10', arcana: 'major', number: 10, nameRu: 'Колесо Фортуны', nameEn: 'Wheel of Fortune', keywordsRu: ['перемены', 'циклы', 'судьба'], keywordsEn: ['change', 'cycles', 'fate'], imageKey: 'major_10_wheel' },
    { id: 'major_11', arcana: 'major', number: 11, nameRu: 'Справедливость', nameEn: 'Justice', keywordsRu: ['баланс', 'истина', 'причина и следствие'], keywordsEn: ['balance', 'truth', 'cause and effect'], imageKey: 'major_11_justice' },
    { id: 'major_12', arcana: 'major', number: 12, nameRu: 'Повешенный', nameEn: 'The Hanged Man', keywordsRu: ['пауза', 'новая перспектива', 'жертва'], keywordsEn: ['pause', 'new perspective', 'surrender'], imageKey: 'major_12_hanged_man' },
    { id: 'major_13', arcana: 'major', number: 13, nameRu: 'Смерть', nameEn: 'Death', keywordsRu: ['обновление', 'трансформация', 'завершение'], keywordsEn: ['renewal', 'transformation', 'completion'], imageKey: 'major_13_death' },
    { id: 'major_14', arcana: 'major', number: 14, nameRu: 'Умеренность', nameEn: 'Temperance', keywordsRu: ['баланс', 'исцеление', 'мера'], keywordsEn: ['balance', 'healing', 'moderation'], imageKey: 'major_14_temperance' },
    { id: 'major_15', arcana: 'major', number: 15, nameRu: 'Дьявол', nameEn: 'The Devil', keywordsRu: ['привязанность', 'тень', 'освобождение'], keywordsEn: ['attachment', 'shadow', 'liberation'], imageKey: 'major_15_devil' },
    { id: 'major_16', arcana: 'major', number: 16, nameRu: 'Башня', nameEn: 'The Tower', keywordsRu: ['трансформация старого', 'пробуждение', 'правда'], keywordsEn: ['transformation of the old', 'awakening', 'truth'], imageKey: 'major_16_tower' },
    { id: 'major_17', arcana: 'major', number: 17, nameRu: 'Звезда', nameEn: 'The Star', keywordsRu: ['надежда', 'вдохновение', 'свет'], keywordsEn: ['hope', 'inspiration', 'light'], imageKey: 'major_17_star' },
    { id: 'major_18', arcana: 'major', number: 18, nameRu: 'Луна', nameEn: 'The Moon', keywordsRu: ['интуиция', 'иллюзии', 'подсознание'], keywordsEn: ['intuition', 'illusions', 'subconscious'], imageKey: 'major_18_moon' },
    { id: 'major_19', arcana: 'major', number: 19, nameRu: 'Солнце', nameEn: 'The Sun', keywordsRu: ['радость', 'ясность', 'успех'], keywordsEn: ['joy', 'clarity', 'success'], imageKey: 'major_19_sun' },
    { id: 'major_20', arcana: 'major', number: 20, nameRu: 'Суд', nameEn: 'Judgement', keywordsRu: ['пробуждение', 'призвание', 'возрождение'], keywordsEn: ['awakening', 'calling', 'rebirth'], imageKey: 'major_20_judgement' },
    { id: 'major_21', arcana: 'major', number: 21, nameRu: 'Мир', nameEn: 'The World', keywordsRu: ['целостность', 'завершение', 'успех'], keywordsEn: ['wholeness', 'completion', 'success'], imageKey: 'major_21_world' },
];
const SUITS = ['wands', 'cups', 'swords', 'pentacles'];
const RANKS = [
    'ace', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
    'page', 'knight', 'queen', 'king',
];
const SUIT_NAMES_RU = {
    wands: 'Жезлов',
    cups: 'Кубков',
    swords: 'Мечей',
    pentacles: 'Пентаклей',
};
const SUIT_NAMES_EN = {
    wands: 'Wands',
    cups: 'Cups',
    swords: 'Swords',
    pentacles: 'Pentacles',
};
const RANK_NAMES_RU = {
    ace: 'Туз', two: 'Двойка', three: 'Тройка', four: 'Четвёрка', five: 'Пятёрка',
    six: 'Шестёрка', seven: 'Семёрка', eight: 'Восьмёрка', nine: 'Девятка', ten: 'Десятка',
    page: 'Паж', knight: 'Рыцарь', queen: 'Королева', king: 'Король',
};
const RANK_NAMES_EN = {
    ace: 'Ace', two: 'Two', three: 'Three', four: 'Four', five: 'Five',
    six: 'Six', seven: 'Seven', eight: 'Eight', nine: 'Nine', ten: 'Ten',
    page: 'Page', knight: 'Knight', queen: 'Queen', king: 'King',
};
const SUIT_KEYWORDS_RU = {
    wands: ['страсть', 'действие', 'вдохновение'],
    cups: ['чувства', 'любовь', 'интуиция'],
    swords: ['мысли', 'решения', 'правда'],
    pentacles: ['ресурсы', 'тело', 'материя'],
};
const SUIT_KEYWORDS_EN = {
    wands: ['passion', 'action', 'inspiration'],
    cups: ['feelings', 'love', 'intuition'],
    swords: ['thoughts', 'decisions', 'truth'],
    pentacles: ['resources', 'body', 'matter'],
};
function buildMinor() {
    const cards = [];
    for (const suit of SUITS) {
        for (const rank of RANKS) {
            cards.push({
                id: `minor_${suit}_${rank}`,
                arcana: 'minor',
                suit,
                rank,
                nameRu: `${RANK_NAMES_RU[rank]} ${SUIT_NAMES_RU[suit]}`,
                nameEn: `${RANK_NAMES_EN[rank]} of ${SUIT_NAMES_EN[suit]}`,
                keywordsRu: [...SUIT_KEYWORDS_RU[suit], RANK_NAMES_RU[rank].toLowerCase()],
                keywordsEn: [...SUIT_KEYWORDS_EN[suit], RANK_NAMES_EN[rank].toLowerCase()],
                imageKey: `minor_${suit}_${rank}`,
            });
        }
    }
    return cards;
}
export const MINOR_ARCANA = buildMinor();
export const TAROT_DECK = [
    ...MAJOR_ARCANA,
    ...MINOR_ARCANA,
];
export function findCardById(id) {
    return TAROT_DECK.find((c) => c.id === id);
}
//# sourceMappingURL=deck.js.map